export default __webpack_public_path__ + "static/media/eye-dropper-blackbg.8ad18d76.svg";